// extracted by mini-css-extract-plugin
export default {"servicesItemList":"servicesList_servicesItemList__U1MZ1","servicesListBlock":"servicesList_servicesListBlock__AVEpx","linkTitle":"servicesList_linkTitle__L+FnF"};